import { createFileRoute } from '@tanstack/react-router'
import { SettingsContent, useSettingTitle } from '~/templates/settings'

import { ProfileAvatarForm } from './-components/avatar-form'
import { LocalizationForm } from './-components/localization-form'
import { PersonalInfoForm } from './-components/personal-info-form'
import { ProfileThemeForm } from './-components/theme-form'

export const Route = createFileRoute('/_authenticated/$alias/settings/profile/')({
  component: RouteComponent,
})

function RouteComponent() {
  useSettingTitle(['Profile'])
  return (
    <SettingsContent className="max-w-prose">
      <ProfileAvatarForm />
      <PersonalInfoForm />
      <ProfileThemeForm />
      <LocalizationForm />
    </SettingsContent>
  )
}
